var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3571_5725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 8.66599C6.95329 9.04874 7.31856 9.36545 7.73803 9.59462C8.15749 9.82379 8.62133 9.96007 9.09809 9.99421C9.57485 10.0284 10.0534 9.95957 10.5012 9.79251C10.9491 9.62546 11.3557 9.36404 11.6937 9.02599L13.6937 7.02599C14.3009 6.39732 14.6368 5.55531 14.6292 4.68132C14.6216 3.80733 14.2711 2.97129 13.6531 2.35326C13.035 1.73524 12.199 1.38467 11.325 1.37708C10.451 1.36948 9.609 1.70547 8.98033 2.31266L7.83366 3.45266",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33347 7.33283C9.04716 6.95008 8.68189 6.63338 8.26243 6.40421C7.84297 6.17503 7.37913 6.03875 6.90237 6.00461C6.4256 5.97047 5.94707 6.03925 5.49924 6.20631C5.0514 6.37337 4.64472 6.63479 4.3068 6.97283L2.3068 8.97283C1.69961 9.60151 1.36363 10.4435 1.37122 11.3175C1.37881 12.1915 1.72938 13.0275 2.3474 13.6456C2.96543 14.2636 3.80147 14.6142 4.67546 14.6217C5.54945 14.6293 6.39146 14.2934 7.02013 13.6862L8.16013 12.5462",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3571_5725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworks);
export default __webpack_public_path__ + "static/media/Networks.1779e98021daa061dd4f2afd1df981ce.svg";
export { ForwardRef as ReactComponent };